<!-- Header -->
<nav class="navbar implementation navbar-expand-xl">
  <div class="container px-auto d-flex justify-content-between">
    <div class="d-flex align-items-center">
      <a href="https://www.travelgate.com/" class="navbar-brand">
        <img src="assets/img/logos/logo_travelgate_blue.svg" alt="Logo Travelgate" />
      </a>
      <div class="stamp">
        <img src="assets/img/pages/onboarding/onboarding_stamp_blue_dark.svg" alt="Stamp onboarding" />
        <p class="stamp__pill">Implementation</p>
      </div>
    </div>
    <div>
      <ul class="navbar-nav align-items-center flex-row">
        <li class="nav-item txt">Company: {{ companyName }}</li>
        <li class="nav-item ms-lg-2 ms-xl-0">
          <a
            class="nav-link dropdown-toggle logout-menu-dropdown"
            data-toggle="dropdown"
            data-bs-toggle="dropdown"
            id="dropdown--profile"
            role="button"
            aria-expanded="false"
            #buttonMenu
          >
            <img alt="Avatar" src="{{ userImg }}" />
          </a>
          <ul
            class="dropdown-menu dropdown-menu-end position-absolute dropdown-logout"
            aria-labelledby="dropdown--profile"
            (click)="$event.stopPropagation()"
          >
            <div class="nav-link__nav-profile-info position-relative">
              <div class="nav-profile-info__profile-image d-flex align-self-start mb-1">
                <img src="{{ userImg }}" alt="Avatar" />
                <div class="ms-2 mt-0">
                  <p class="nav-profile-info__profile-name mb-0">
                    {{ userName }}
                  </p>
                  <p class="nav-profile-info__profile-email mb-1">
                    {{ loggedUser?.email }}
                  </p>
                  <div class="d-flex align-items-center">
                    <p class="copy-bearer">
                      <xen-link
                        [size]="'small'"
                        [weight]="'regular'"
                        [label]="'Copy bearer'"
                        [icon]="true"
                        [icon_snippet]="'fas fa-copy'"
                        [icon_placement]="'left'"
                        [theme]="'blue'"
                        (click)="copyBearerToClipboard()"
                      ></xen-link>
                    </p>
                  </div>
                </div>
              </div>
              <!-- Header select organization -->
              <tgx-selected-organization />
              <!-- logout -->
              <li class="settings">
                <div class="settings">
                  <xen-link
                    size="body"
                    weight="regular"
                    label="Sign out"
                    [icon]="true"
                    icon_snippet="fa-regular fa-right-from-bracket"
                    icon_placement="left"
                    theme="dark"
                    target="_self"
                    [underlined]="false"
                    [block]="true"
                    (click)="signOut()"
                  ></xen-link>
                </div>
              </li>
            </div>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>

@if (bearerCopied) {
  <div class="floating-xen-tag">
    <xen-tag
      [size]="'large'"
      [label]="'Bearer token copied'"
      [icon]="true"
      [icon_snippet]="'fa-regular fa-copy'"
      [icon_placement]="'left'"
      [type]="'success'"
    ></xen-tag>
  </div>
}

<div class="container">
  <div class="section mt-5">
    @if (isBuyerAndSeller) {
      <xen-alert type="info" [dismiss]="true">
        <div class="d-flex align-items-center justify-content-center">
          <i class="fas fa-circle-info me-2"></i>
          <p class="mb-0 me-3">
            We see <span class="fw-bold">you have another company profile</span> ({{ companyName }}) with onboarding
            completed.
            <xen-link
              [size]="'body'"
              [weight]="'regular'"
              [label]="'Click here to switch'"
              (click)="changeOrganizationType()"
            ></xen-link>
            and go to the app.
          </p>
        </div>
      </xen-alert>
    }
  </div>
</div>
